/**
 * endpoints.js — registro op->handler que el drain despacha (re-impl LIMPIA de v1 endpoints.js).
 *
 * El outbox no conoce los endpoints: solo despacha por nombre de operacion. Cada modulo de
 * handlers (los trae el plan 04-02) registra el handler de sus ops via registerOp(). Mantiene
 * la regla de capas (la capa sync no duplica builders/routes aqui).
 *
 * Un handler recibe la FILA del outbox y devuelve `{ server_id?, committed?, ...result }`.
 * 04-01 lo entrega VACIO (sin handlers): el drain es testeable registrando ops fake en el spec.
 *
 * NO importa nada de la app (ni v1, ni el plugin): es infraestructura pura de registro.
 */

const registry = {}

/** Registra el handler de una operacion. Ej: registerOp('task.create', fn). */
export function registerOp (op, handler) {
  registry[op] = handler
}

/** True si la operacion tiene handler registrado. */
export function hasOp (op) {
  return Object.prototype.hasOwnProperty.call(registry, op)
}

/**
 * Despacha la fila del outbox al handler registrado.
 * Si no hay handler -> lanza (el drain lo clasifica como retry transitorio, NO dead, porque el
 * error no lleva status: ver classify.js rama null).
 */
export function dispatch (row) {
  const handler = registry[row.op]
  if (!handler) throw new Error(`Sin handler para op="${row.op}"`)
  return handler(row)
}

/** Vacia el registro (aislamiento entre tests). */
export function _clearRegistry () {
  for (const k of Object.keys(registry)) delete registry[k]
}
